import { createHook, createStore } from 'react-sweet-state';

import { fg } from '@atlaskit/platform-feature-flags';

const store = createStore({
	initialState: {
		isOpen: false,
	},
	name: 'DebugModalStore',
	actions: {
		openDebugModal:
			() =>
			({ setState }) => {
				setState({
					isOpen: true,
				});
			},
		closeDebugModal:
			() =>
			({ setState }) => {
				setState({
					isOpen: false,
				});
			},
	},
});

const useStore = createHook(store);

export const useDebugController = (): {
	isDebugEnabled: boolean;
	isDebugModalOpen: boolean;
	openDebugModal: () => void;
	closeDebugModal: () => void;
} => {
	const [{ isOpen }, { openDebugModal, closeDebugModal }] = useStore();

	return {
		isDebugEnabled: fg('ai_mate_debug_enabled'),
		isDebugModalOpen: isOpen,
		openDebugModal,
		closeDebugModal,
	};
};
